import { Link } from "react-router-dom";
import { CreditCard, MousePointerClick, PackageCheck, UserPlus } from "lucide-react";
import { Section } from "./About";

const STEPS = [
  { icon: UserPlus, title: "Create your account", text: "Sign up with your phone number and a secure password. It's free and takes less than a minute." },
  { icon: MousePointerClick, title: "Choose a product", text: "Browse the catalogue, open a product to read the details and click Buy." },
  { icon: CreditCard, title: "Pay with theteller", text: "You're redirected to theteller's secure checkout to pay with Mobile Money or card. We never see your PIN or card details." },
  { icon: PackageCheck, title: "Get instant access", text: "Our server verifies the payment with theteller. Once confirmed, your product appears in My Purchases immediately." },
];

export default function HowItWorks() {
  return (
    <Section eyebrow="How it works" title="Simple, secure, instant." text="Here's exactly what happens from the moment you find a product to the moment you can use it.">
      <div className="mt-16 grid gap-5 md:grid-cols-2">
        {STEPS.map((s, i) => (
          <div key={s.title} className="card-rx card-hover relative p-8">
            <span className="absolute right-6 top-6 font-mono-rx text-5xl font-bold text-white/[0.04]">0{i + 1}</span>
            <s.icon className="text-emerald-400" size={26} />
            <h3 className="mt-6 text-xl font-semibold text-white">{s.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-400">{s.text}</p>
          </div>
        ))}
      </div>
      <div className="mt-12 flex flex-wrap gap-3">
        <Link to="/register" className="btn-primary" data-testid="how-register-btn">Create account</Link>
        <Link to="/payment-policy" className="btn-ghost">Read payment policy</Link>
      </div>
    </Section>
  );
}
